"use client";

import React from "react";

import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=707%3A857))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const ImageLandscape = createSVGIcon(
  <>
    <path
      d="M2.57 23.14h18.856c.947 0 1.715-.767 1.715-1.714V2.57c0-.947-.768-1.714-1.715-1.714H2.57c-.947 0-1.714.767-1.714 1.714v18.857c0 .947.767 1.715 1.714 1.715ZM.855 18.856h22.286"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m6.582 18.857 8.932-8.365a.86.86 0 0 1 1.097 0l6.531 4.68M7.712 10.284a2.571 2.571 0 1 0 0-5.143 2.571 2.571 0 0 0 0 5.143Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "ImageLandscape",
  { viewBox: "0 0 24 24", fill: "none", className: iconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
